import React from 'react';
import type {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';

import {useAuthStore} from '@/entities/session/auth-store';
import type {DevicesStackParamList} from '@/app/routes';
import {DeviceCard} from '@/features/view-devices/ui/DeviceCard';
import {AppButton} from '@/shared/ui/button';
import {Page} from '@/shared/ui/page';

/** «Устройства» → карточка терминала: состояние, режим прохода, путь в настройки. */
type Props = NativeStackScreenProps<DevicesStackParamList, 'Device'>;

export function DeviceScreen({route, navigation}: Props) {
  const {t} = useTranslation();
  const companyId = useAuthStore(s => s.activeContext?.companyId);
  const {deviceId, name} = route.params;

  return (
    <Page
      scroll
      width="form"
      title={name}
      testID="device-screen"
      actions={
        <AppButton
          title={t('terminal.settings')}
          tone="outline"
          icon="settings"
          onPress={() => navigation.navigate('DeviceSettings', {deviceId, name})}
          testID="device-open-settings"
        />
      }>
      {companyId ? (
        <DeviceCard
          companyId={companyId}
          deviceId={deviceId}
          onOpenSettings={() => navigation.navigate('DeviceSettings', {deviceId, name})}
        />
      ) : null}
    </Page>
  );
}
